module.exports = __webpack_public_path__ + "static/media/gephaz_acelszerkezeti_es_felujitasi_munkai.703e5435.jpg";